// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import DebitItem from '@deere/cps-it.warranty-model-factory/lib/partial-debit';
import EditableField from '../../../../shared/components/editable-field';
import FormattedNumberInput from '../../../../shared/components/formatted-number-input';
import KeyValueDropDown from '../../../../claim/shared/components/claim-fields/key-value-dropdown';
import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import {getAmountWithCurrency} from '../../services/partial-debit-helper';

function handleAdjustmentValueChange(value) {

    this.onAdjustmentValueChange(value);

}

function handleAdjustmentTypeChange(event) {

    this.onAdjustmentTypeChange(event.target.value);

}

const DebitLaborPanelRowBody = props =>
    <section className='debit-labor-panel-row-body'>
        <span className='description'>{props.labor.description}</span>
        <span className='amount'>{getAmountWithCurrency(props.labor.amount, props.labor.currency)}</span>
        <span className='hours'>{props.labor.quantity}</span>
        <EditableField
            className='adjustment-type'
            isEditable={props.isEditable}
            value={props.labor.adjustmentType.value}
        >
            <KeyValueDropDown
                className='adjustment-type'
                list={props.adjustmentTypes}
                onChange={props::handleAdjustmentTypeChange}
                showBlankOption={false}
                value={props.labor.adjustmentType.key}
            />
        </EditableField>
        <EditableField
            className='value-of-adjustment'
            isEditable={props.isEditable && props.labor.adjustmentType.key !== '01'}
            value={props.labor.adjustmentType.key === 'AMOUNT' ? getAmountWithCurrency(props.labor.valueOfAdjustment, props.labor.currency) : props.labor.valueOfAdjustment}
        >
            <FormattedNumberInput
                allowNegative={false}
                className='value-of-adjustment'
                decimalPrecision={2}
                onValueChange={props::handleAdjustmentValueChange}
                value={props.labor.valueOfAdjustment}
            />
        </EditableField>
    </section>;

DebitLaborPanelRowBody.displayName = 'DebitLaborPanelRowBody';
DebitLaborPanelRowBody.propTypes = {
    adjustmentTypes: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)),
    isEditable: PropTypes.bool.isRequired,
    labor: PropTypes.instanceOf(DebitItem).isRequired,
    onAdjustmentTypeChange: PropTypes.func,
    onAdjustmentValueChange: PropTypes.func
};

export default DebitLaborPanelRowBody;



// WEBPACK FOOTER //
// ./src/tcsm/partial-debit/components/debit-labor-panel/debit-labor-panel-row-body.js